"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationPosition = void 0;
var organisation_position_card_1 = require("../../components/entities/organisation-position-card");
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
exports.OrganisationPosition = {
  name: 'OrganisationPosition',
  components: {
    card: organisation_position_card_1.OrganisationPositionCard
  },
  autoRoutes: ['create', 'update'],
  table: {
    fieldNames: ["organisation", "person", "primary", "positions"]
  },
  /* -------------- FORM -------------- */
  form: {
    paginate: false,
    bufferAtEnd: 300,
    modal: {
      maxWidth: '700px'
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      // person: { type: 'linked', entityTypeName: 'Person', variant: 'forOrganisation', required: true, description: 'Who is the person in this {{POSITION}}?' },
      organisation: {
        type: 'linked',
        label: "Organisation",
        entityTypeName: 'Organisation',
        variant: 'forPerson',
        required: true,
        description: 'Which {{ORGANISATION}} is this {{POSITION}} held in?'
      },
      positions: {
        type: 'linkedMultiple',
        label: "Positions",
        entityTypeName: 'Position',
        required: true,
        description: 'Select one or more position names for this {{Person.label}}. Note – when entering a dual role, it\'s best to select two names, e.g. select both \'Founder\' and \'CEO\' for someone who is both a Founder and CEO'
      },
      primary: {
        type: 'boolean',
        label: 'Primary Position',
        description: 'Is this position their primary position?',
        variant: 'forPerson'
      }
    })
  },
  list: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position\n      person { \n        id name type slug isDraft isPublished\n        position\n        bio { id plainTruncated: plain(truncate: { words: 60 }) }\n        positions { \n          position\n          organisation { \n            id name slug\n            logo { id url }\n            location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n          }\n        }\n        photo { id url thumbnails { id full { id url width height } } }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      }\n    "], ["\n      position\n      person { \n        id name type slug isDraft isPublished\n        position\n        bio { id plainTruncated: plain(truncate: { words: 60 }) }\n        positions { \n          position\n          organisation { \n            id name slug\n            logo { id url }\n            location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n          }\n        }\n        photo { id url thumbnails { id full { id url width height } } }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      }\n    "])))
  }
};
var templateObject_1;